import React, { useMemo } from 'react';
import { DatePicker } from '@ihsm/ui-shared';
import { useAppSelector } from 'state/store';

export const ValuationDatePicker: React.FC = () => {
  const { selectedValuationDate } = useAppSelector(
    (state) => state.valuationDatesState
  );

  const valuationDate = useMemo(
    () => new Date(selectedValuationDate),
    [selectedValuationDate]
  );

  return (
    <DatePicker labelText="Date" value={valuationDate} onChange={() => {}} />
  );
};
